import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'modify_summary';
export const route = 'modify_summary/[[...token]]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import(/* webpackChunkName: "modify_summary" */
/* webpackPrefetch: true */
'../components/SummaryPage')));